import { useTenantNavigate } from '@app-store'
import { ColumnListType, DataType, Table } from '@ui-kit'
import { noop } from 'lodash'
const IntakeQueue = () => {
  const navigate = useTenantNavigate()
  const columns: ColumnListType[] = [
    {
      label: 'Name',
      key: 'name',
      type: '',
    },
    {
      label: 'Case ID',
      key: 'case_id',
      type: '',
    },
    {
      label: 'Date of Birth',
      key: 'date_of_birth',
      type: '',
    },
    {
      label: 'Gender',
      key: 'gender',
      type: '',
    },
    {
      label: 'Product Name',
      key: 'product_name',
      type: '',
    },
    {
      label: 'Provider Name',
      key: 'provider_name',
      type: '',
    },
    {
      label: 'Risk',
      key: 'risk',
      type: 'component',
    },
  ]

  const data: DataType[] = [
    {
      name: 'Bill Martin',
      case_id: '114563',
      date_of_birth: '03/10/1962',
      gender: 'Male',
      product_name: 'Tecfidera',
      provider_name: 'Dr. Jonathan Smith',
      risk: 'low',
    },
    {
      name: 'Jane Smith',
      case_id: '24235',
      date_of_birth: '04/12/1951',
      gender: 'Female',
      product_name: 'Tecfidera',
      provider_name: 'Sr. Scott Schmider',
      risk: 'low',
    },
    {
      name: 'Robert Johnson',
      case_id: '22145',
      date_of_birth: '03/10/1962',
      gender: 'Male',
      product_name: 'Tecfidera',
      provider_name: 'Dr. Harry Lewis',
      risk: 'high',
    },
    {
      name: 'Emily Davis',
      case_id: '236587',
      date_of_birth: '02/22/1987',
      gender: 'Female',
      product_name: 'Tecfidera',
      provider_name: 'Dr. Claire Dunphy',
      risk: 'medium',
    },
    {
      name: 'Micheal Brown',
      case_id: '214478',
      date_of_birth: '03/10/1962',
      gender: 'Male',
      product_name: 'Tecfidera',
      provider_name: 'Dr. Mike Ross',
      risk: 'low',
    },
  ]

  const handleRowClick = (
    e: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    record: DataType,
    index: number
  ) => {
    e.stopPropagation()
    if (index === 0 && record) {
      console.log('navigation triggered')
      navigate('patient-adherence')
    }
  }

  const getRiskClasses = (
    dataItem: DataType
  ): { bgClass: string; textClass: string } => {
    const riskLevel = dataItem?.risk?.toString().toLowerCase()
    let bgClass: string
    let textClass: string
    if (riskLevel === 'low') {
      bgClass = 'bg-green-50'
      textClass = 'text-[#3DBC60]'
    } else if (riskLevel === 'medium') {
      bgClass = 'bg-yellow-50'
      textClass = 'text-[#EF9400]'
    } else {
      bgClass = 'bg-red-50'
      textClass = 'text-[#EC4E2C]'
    }
    return { bgClass, textClass }
  }

  return (
    <div className="flex flex-col gap-4 font-primary">
      <div className="top font-primary flex justify-between p-3">
        <div className="left flex flex-col ">
          <span className="text-base font-medium">Intake Que</span>
          <span className="text-xs font-light">
            Below is a list of patients currently in the intake process. Click
            on a patient&apos;s name to view their Adherence Details
          </span>
        </div>
        <div className="right flex gap-2">
          <div className="bg-[#FAFAFA] p-2">
            <span className="text-[#EC4E2C] text-xs">High: </span>{' '}
            <span className="text-xs font-light">Greater than 6</span>
          </div>
          <div className="bg-[#FAFAFA] p-2">
            <span className="text-[#EF9400] text-xs">Medium: </span>
            <span className="text-xs font-light">Between 4 and 6</span>
          </div>
          <div className="bg-[#FAFAFA] p-2">
            <span className="text-[#3DBC60] text-xs">Low: </span>{' '}
            <span className="text-xs font-light">Below 4</span>
          </div>
        </div>
      </div>
      {/* Top Ends Here */}
      <div className="shadow-lg p-2">
        <div className="p-4 border rounded-lg border-[#E3E3E3]">
          <Table
            columnList={columns}
            data={data}
            additionalColumns={[]}
            handleChange={noop}
            handleRowClick={handleRowClick}
            headerClick={noop}
          >
            {(dataItem) => {
              const { bgClass, textClass } = getRiskClasses(dataItem)

              return (
                <div
                  className={`flex items-center justify-center h-8 w-20 rounded ${bgClass}`}
                >
                  <span
                    className={`${textClass} font-light capitalize text-xs`}
                  >
                    {dataItem.risk}
                  </span>
                </div>
              )
            }}
          </Table>
        </div>
      </div>
    </div>
  )
}

export default IntakeQueue
